import axiosTokenInstance from "services/api/backoffice";
import { GET_CAMPAING, GET_CAMPAING_ERROR } from "_models/redux/types";

// Action function
export const getCampaingAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/callcenter/campaigns?status=all`
        );

        const { data, status } = response || {};

        dispatch({
            method: "get",
            payload: data || {},
            status: status || {},
            type: GET_CAMPAING,
        });
    } catch (e) {
        dispatch({
            method: "get",
            payload: e || {},
            type: GET_CAMPAING_ERROR,
        });
    }
};
